module.exports = __webpack_public_path__ + "assets/img/icon6-menu.2d26f8cc.svg";